import React from 'react';
import GuidelineCard from "./components/guidelineCard";
import DataLoader from "../../components/loader/dataLoader";
import defaultIcon from "../../assets/images/deafult/default-small-image.png";
import "../../assets/css/adminPages/guideline/style.scss";
import useGuidelines from "../../hooks/admin/useGuidelines";

const Index = () => {
  const {
    data,
    isLoading,
    demoGuidelineObj,
    handleDelete,
    handleUpdate,
    handleChange,
    handleIconChange,
    handlePdfFileChange,
    handleModalIconChange,
    handleModalChange,
    handleModalPdfFileChange,
    handleModalUpdate,
    fileInputRef,
    iconInputRef,
    handleCloseModal,
    modalCloseIconButton
  } = useGuidelines();

  return (
      <div className='guideline-update-section'>
        <div className='custom-container'>
          <div className='content-section'>
            <h1 className='page-title'>Guidelines</h1>
            <div className='content-body'>
              <div className="row">
                <div className='col-12 pb-4'>
                  <div className="text-right">
                    <button type='button' className='add-btn' data-toggle="modal"
                            data-target="#exampleModal">
                      Add Guildeline +
                    </button>
                  </div>
                  <div className="modal fade" data-backdrop="static" data-keyboard="false" id="exampleModal" tabIndex="-1"
                       aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">Add Guideline</h5>
                          <button ref={modalCloseIconButton} type="button" className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  onClick={handleCloseModal}
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body bg-light">
                          <div className="guideline-custom-card">
                            <div className="guideline-custom-card-header"
                                 style={{background: demoGuidelineObj.backgroundColor}}>
                              <div className="image-uploader">
                                <label className="icon-update-btn" htmlFor="uploader">
                                  <i className="fa fa-pencil"></i>
                                </label>
                                <input ref={iconInputRef} onChange={handleModalIconChange} id="uploader"
                                       className="d-none" type="file" accept="image/*"/>
                              </div>
                              <img
                                  src={demoGuidelineObj.icon ? `data:image/jpg;base64,${demoGuidelineObj.icon}` : defaultIcon}
                                  alt=""
                              />
                            </div>
                            <div className="guideline-custom-card-body">
                              <div className='form__div-container w-100'>
                                <div className="form__div">
                                  <input
                                      required
                                      type='text'
                                      name="titleEn"
                                      maxLength={22}
                                      className="form__input"
                                      placeholder=" "
                                      onChange={handleModalChange}
                                      value={demoGuidelineObj.titleEn}
                                  />
                                  <label htmlFor="" className="form__label">Title</label>
                                </div>
                              </div>
                              <div className='form__div-container w-100'>
                                <div className="form__div">
                                  <input
                                      required
                                      type='color'
                                      name="backgroundColor"
                                      className="form__input clickable"
                                      placeholder=" "
                                      onChange={handleModalChange}
                                      value={demoGuidelineObj.backgroundColor}
                                  />
                                  <label htmlFor="" className="form__label">Backgroud
                                    Color</label>
                                </div>
                              </div>
                              <div className='form__div-container w-100 mb-3'>
                                <div className='d-flex align-items-center'>
                                  <label htmlFor="pdfUploader">
                                    <i className='fa fa-cloud-upload fa-2x clickable'
                                       style={{color: "#354e80"}}></i>
                                  </label>
                                  <input
                                      ref={fileInputRef}
                                      onChange={handleModalPdfFileChange}
                                         id="pdfUploader" type="file" className='d-none'/>
                                  <p title={demoGuidelineObj.file}
                                     className='mb-2 ml-2 text-nowrap overflow-hidden'
                                     style={{textOverflow: "ellipsis"}}>{demoGuidelineObj.file}</p>
                                </div>
                              </div>
                              <div className='text-center'>
                                <button onClick={handleModalUpdate} type="submit"
                                        className="save-btn btn-block">Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12'>
                  {isLoading && <DataLoader/>}
                </div>
                {data && data?.map((guideline) => (
                    <div key={guideline.id} className="col-xl-3 col-lg-4 col-md-6">
                      <GuidelineCard
                          guideline={guideline}
                          handleChange={handleChange}
                          handleIconChange={handleIconChange}
                          handlePdfFileChange={handlePdfFileChange}
                          handleDelete={handleDelete}
                          handleUpdate={handleUpdate}
                      />
                    </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Index;
